import L from "leaflet";

export class MapZoomButton {
  /** Mapa Leaflet (se setea en `init`). */
  private _map!: L.Map;
  /** Botón del control. */
  private _btn: HTMLButtonElement | null = null;
  /** Handler del click (nombrado para poder removerlo). */
  private _onBtnClick = (): void => this._onClick(this._map);

  /**
   * @param _icon    Icono Phosphor del botón (ej: "ph-plus").
   * @param _title   Tooltip del botón.
   * @param _onClick Acción a ejecutar con el mapa al pulsarse.
   */
  constructor(
    private readonly _icon: string,
    private readonly _title: string,
    private readonly _onClick: (map: L.Map) => void,
  ) {}

  /** Registra el botón en el contenedor y cablea la acción. */
  init(parent: HTMLElement, map: L.Map): void {
    this._map = map;
    const btn = L.DomUtil.create("button", "sx-map-btn") as HTMLButtonElement;
    btn.innerHTML = `<i class="ph ${this._icon}"></i>`;
    btn.title = this._title;
    L.DomEvent.disableClickPropagation(btn);
    L.DomEvent.on(btn, "click", this._onBtnClick);
    this._btn = btn;
    parent.appendChild(btn);
  }

  /** Habilita/deshabilita el botón (deshabilitado no dispara la acción). */
  setDisabled(disabled: boolean): void {
    if (this._btn) this._btn.disabled = disabled;
  }

  /** Quita el listener del botón. */
  dispose(): void {
    if (this._btn) L.DomEvent.off(this._btn, "click", this._onBtnClick);
    this._btn = null;
  }
}
